export var Environment;
(function (Environment) {
    Environment["CI"] = "ci";
    Environment["Development"] = "development";
    Environment["Staging"] = "staging";
    Environment["Future"] = "future";
    Environment["Production"] = "production";
    Environment["Pentest"] = "pentest";
})(Environment || (Environment = {}));
//# sourceMappingURL=environment.js.map